"use client"

import { AbstractIntlMessages, NextIntlClientProvider } from "next-intl"
import { FC, PropsWithChildren } from "react"
import { timeZone } from "./constants"

interface I18nProviderProps {
  locale: string
  translations?: AbstractIntlMessages
}

const I18nProvider: FC<PropsWithChildren<I18nProviderProps>> = ({
  children,
  locale,
  translations,
}) => (
  <NextIntlClientProvider locale={locale} messages={translations} timeZone={timeZone}>
    {children}
  </NextIntlClientProvider>
)

export default I18nProvider
